import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ExpiryAdjustmentSlice {
    items: Array<{
        productVariationId: string;
        purchaseItemId: string;
        quantity: number;
        productName?: string;
        brandName?: string;
        purchasePrice?: string;
        wholesalePrice?: string;
        retailPrice?: string;
        expirationDate?: string;
        updatedPurchasePrice?: string;
    }>;
}

const initialState: ExpiryAdjustmentSlice = {
    items: [],
};

export const expiryAdjustmentSlice = createSlice({
    name: `expiryAdjustment`,
    initialState,
    reducers: {
        addExpiryAdjustmentItem: (
            state,
            action: PayloadAction<ExpiryAdjustmentSlice['items'][number]>,
        ) => {
            // check if item already exists
            const exists = state.items.find(
                (item) => item.purchaseItemId === action.payload.purchaseItemId,
            );

            if (exists) {
                return;
            }

            state.items = [...state.items, action.payload];
        },

        removeExpiryAdjustmentItem: (state, action: PayloadAction<string>) => {
            state.items = state.items.filter(
                (item) => item.purchaseItemId !== action.payload,
            );
        },

        clearExpiryAdjustmentItems: (
            state,
            _action: PayloadAction<undefined>,
        ) => {
            state.items = [];
        },
    },
});

export const {
    addExpiryAdjustmentItem,
    removeExpiryAdjustmentItem,
    clearExpiryAdjustmentItems,
} = expiryAdjustmentSlice.actions;
